import { render, staticRenderFns } from "./geocercasGrupos.vue?vue&type=template&id=127868e0&scoped=true&"
import script from "./geocercasGrupos.vue?vue&type=script&lang=js&"
export * from "./geocercasGrupos.vue?vue&type=script&lang=js&"
import style0 from "./geocercasGrupos.vue?vue&type=style&index=0&id=127868e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127868e0",
  null
  
)

export default component.exports